import React from "react";
import {injectIntl} from "react-intl";
import LinkListItem from "@Components/LinkListItem";

function LinkList ({appSettings, bgColorClass = "bg-variant-brand-tertiary"}) {
  if (!appSettings || !appSettings.seo_linklist_branch) {
    return null;
  }

  let options = [];
  const keys = ["first_row", "second_row"]

  keys.map(key => {
    const columnsData = appSettings.seo_linklist_branch[key]

    for (let columnId in columnsData) {
      const columnData = columnsData[columnId];
      if (!columnData[`${columnId}_links`]) {
        continue;
      }

      const links = columnData[`${columnId}_links`].split('\r\n');
      const linksData = links.map((item, index) => {
        const data = item.split('|');

        return {
          title: data[0],
          url: data[1]
        }
      });

      options.push(
        <LinkListItem key={columnId} title={columnData[`${columnId}_name`]} links={linksData} />
      )
    }
  });

  if (!options.length) {
    return null;
  }

  return (
    <div className={`block ${bgColorClass} seo-link`}>
      <div className="block__wrapper block__wrapper--stacked">
        <div className="block__header block__header--l wrapper">
          <h2 className="block__title">
            { appSettings.seo_linklist_branch.seo_linklist_name }
          </h2>
        </div>
        <div className="block__content wrapper">
          <div className="seo-links__grid">
            { options }
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(LinkList);
